export default __webpack_public_path__ + "static/media/ten.a8be6c29.webp";